import { getFeature } from 'Cloud/Application/FeaturesEs6';

/**
 * @see https://jira.vk.team/browse/CLOUDWEB-20159
 */
export const COLLECT_IMAGE_ERROR_TRACES = getFeature('collect-image-error-traces') || false;
